let pending = false;
const listeners = new Set();

export const appUpdate = {
  subscribe: (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
  getSnapshot: () => pending,
  markPending: () => {
    if (!pending) {
      pending = true;
      listeners.forEach((fn) => fn());
    }
  },
};
